import { useState } from 'react';

import { SubscribePlan } from '@zep/types';
import { Colors } from '@zep/ui-tokens';

/**
 * 프라이싱 페이지 내 플랜별 버튼의 색을 변경하기 위한 훅
 * @description Free 플랜은 제외(variant = 'sub'), basic, pro, enterprise 플랜만 적용
 * @returns {Object} hoverStates, handleMouseEnter, handleMouseLeave, pricingButtonStyle
 */
export const usePricingHoverButton = () => {
  const [hoverStates, setHoverStates] = useState({
    basic: false,
    pro: false,
    enterprise: false,
  });

  const pricingButtonStyle = {
    basic: {
      backgroundColor: Colors.MintDark,
      backgroundHoverColor: Colors.MintDarkHover,
    },
    pro: {
      backgroundColor: Colors.PrimaryDefault,
      backgroundHoverColor: Colors.PrimaryDefaultHover,
    },
    enterprise: {
      backgroundColor: Colors.Gray600,
      backgroundHoverColor: Colors.GrayDefaultHover,
    },
  };

  const handleMouseEnter = (planKey: Exclude<SubscribePlan, 'free'>) => {
    setHoverStates(prevStates => ({ ...prevStates, [planKey]: true }));
  };

  const handleMouseLeave = (planKey: Exclude<SubscribePlan, 'free'>) => {
    setHoverStates(prevStates => ({ ...prevStates, [planKey]: false }));
  };

  return {
    hoverStates,
    handleMouseEnter,
    handleMouseLeave,
    pricingButtonStyle,
  };
};
